import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom';
import qs from 'qs';
import buscarFechamentoCaixaAgencia from '../../../actions/fechamento-caixa/agencia/buscarFechamentoCaixaAgencia';
import { arredondamentoPadrao, formatarReal, realParaNumber } from '../../../util/numberUtil';

export class PainelDetalhamentoFechamentoCaixaAgencia extends React.Component {
  constructor (props) {
    super(props);
    this.componentRef = React.createRef();
  }

  imprimir () {
    window.print();
  }

  componentDidMount () {
    if (this.props.empresaSelecionada.id) {
      const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
      if (parametros.fechamento) {
        this.props.buscarFechamentoCaixaAgencia(this.props.empresaSelecionada.id, parametros.fechamento);
      }
    } else {
      this.props.history.push('/painel-fechamento-caixa')
    }
  }

  exbirLinhaTotal (titulo, valor) {
    return <tr>
      <td>
        {titulo}
      </td>
      <td>
        {arredondamentoPadrao(realParaNumber(valor)).toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL'
        })}
      </td>
    </tr>
  }

  exibirHistoricos () {
    if (this.props.fechamentoCaixa.historicos && this.props.fechamentoCaixa.historicos.length) {
      return <table className="table table-sm table-striped table-bordered text-center page-break">
        <thead>
        <tr>
          <td colSpan={8}>
            <strong>Movimentações do caixa</strong>
          </td>
        </tr>
        <tr>
          <th scope="col">Data e Hora</th>
          <th scope="col">Situação</th>
          <th scope='col'>Usuário</th>
          <th scope="col">Observação</th>
        </tr>
        </thead>
        <tbody>
        {this.props.fechamentoCaixa.historicos.map(historico =>
          <tr key={`historico-${historico.dataHora}`}>
            <td>
              <span>{historico.dataHora}</span>
            </td>
            <td>
              <span>{historico.descricaoSituacao}</span>
            </td>
            <td>
              <span>{historico.nomeUsuario}</span>
            </td>
            <td>
              <span>{historico.observacao}</span>
            </td>
          </tr>)}
        </tbody>
      </table>
    }
  }

  exibirSinalSubtracao (situacao, valor) {
    if (['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(situacao)
      && realParaNumber(valor) > 0) {
      return ' -';
    }
  }

  exibirValorNegativo (reservas, reservaCorrente, origem) {
    let valor = 'R$ 0.00';
    reservas.filter(f=> f.situacao === 'Aprovado').forEach(reserva => {
      reserva.reservas.forEach(reserva2 => {
        if (reserva2.id === reservaCorrente.id) {
          valor = origem === 'I' ? `- R$${reserva2.impostoRetido}` : `- R$${reserva2.comissao}`;

        }
      })
    });

    return valor === '- R$0.00'? 'R$0.00' : valor
  }


  exibirValorNegativoImposto (valor) {
    return valor > 0 ? <span>-{formatarReal(valor)}</span> : <span>R$0.00</span>
  }

  exibirValorImpostoRetidoAprovadas (reservas, reservaCorrente) {
    let valor = formatarReal(reservaCorrente.impostoRetido);
    reservas.filter(f=> f.situacao === 'Cancelado').forEach(reserva => {
      reserva.reservas.forEach(reserva2 => {
        if (reserva2.id === reservaCorrente.id &&
          reservaCorrente.idRemarcada !== null &&
          reservaCorrente.custoRemarcacao === null
        ) {
          valor = 'R$0,00';
          return;
        }
      })
    });
    return valor
  }

  exbibirReservas (fechamento,situacoes, titulo) {
    if(fechamento.detalhamentoFechamentoCaixaUsuarioDtos){
      const detalhamentosUsuarios = fechamento.detalhamentoFechamentoCaixaUsuarioDtos.filter(f => f.reservas !== null && situacoes.includes(f.situacao));
      if (detalhamentosUsuarios.length > 0) {
        return <table key={detalhamentosUsuarios.nomeVendedor}
                      className="table table-sm table-striped table-bordered text-center page-break">
          <thead>
          <tr>
            <td colSpan={9}>
              <strong>{titulo}</strong>
            </td>
          </tr>
          <tr>
            <th scope="col">Pedido</th>
            <th scope="col">Passageiro</th>
            <th scope='col'>Situação</th>
            <th scope="col">Poltrona</th>
            <th scope="col">Pagamento</th>
            <th scope="col">VL Imposto</th>
            <th scope="col">VL Comissão</th>
            <th scope="col">VL Pedágio</th>
            {situacoes.includes('Cancelado') ? <th scope="col">Valor de estorno</th> : null}
            <th scope="col">Valor</th>
          </tr>
          </thead>
          <tbody>
          {detalhamentosUsuarios.map(detalhamento => detalhamento.reservas.map(reserva =>
            <tr key={`reserva-${reserva.id}`}>
              <td>
                <span>{reserva.pedidoId}</span>
              </td>
              <td>
                <span>{reserva.passageiroDto.nome}</span>
              </td>
              <td>
                <span>{detalhamento.situacao}</span>
              </td>
              <td>
                <span>{reserva.numeroPoltrona}</span>
              </td>
              <td>
                <span>{reserva.descricaoFormasPagamento}</span>
              </td>
              <td>
                {['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(detalhamento.situacao) ?                
                  this.exibirValorNegativoImposto(reserva.estornoImpostoRetido) :
                  <span>{this.exibirValorImpostoRetidoAprovadas(detalhamentosUsuarios, reserva)}</span>
                }
              </td>
              <td>
                {['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(detalhamento.situacao) ?
                  this.exibirValorNegativo(detalhamentosUsuarios, reserva, 'C') :
                  <span>{formatarReal(reserva.comissao)}</span>
                }
              </td>
              <td>
                {['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(detalhamento.situacao) ?
                    this.exibirValorNegativo(detalhamentosUsuarios, reserva, 'C') :
                    <span>{formatarReal(reserva.pedagio)}</span>
                }
              </td>
              {situacoes.includes('Cancelado')
                || situacoes.includes('Cancelado/Reembolso Efetuado') ?
                <td>
                  <span>{['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(detalhamento.situacao) ? formatarReal(reserva.valorEstorno) : '-'}</span>
                </td> : null}
              <td>
                {reserva.seRemarcacao && !['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(detalhamento.situacao) ?
                  <span>{this.exibirSinalSubtracao(detalhamento.situacao, reserva.custoRemarcacao)}{formatarReal(reserva.custoRemarcacao)}</span> :
                  <span>{this.exibirSinalSubtracao(detalhamento.situacao, reserva.valorTotalReserva)}{formatarReal(reserva.valorTotalReserva)}</span>}
              </td>

            </tr>))}
          </tbody>
          {situacoes.includes('Aprovado') ?
            <tfoot>
            <tr className='border border-dark'>
              <td colSpan={5}>
                <strong><span>TOTAIS</span></strong>
              </td>
              <td><span>{formatarReal(fechamento.totalImpostoRetido)}</span></td>
              <td>{formatarReal(fechamento.totalComissao)}</td>
              <td/>
              <td>{formatarReal(fechamento.valorTotal)}</td>
            </tr>
            </tfoot> : null
          }
        </table>
      }
      return null

    }
    return null
  }

  exbibirEncomendas (fechamento,situacoes, titulo) {
    if(fechamento.detalhamentoFechamentoCaixaUsuarioDtos){
      const detalhamentosUsuarios = fechamento.detalhamentoFechamentoCaixaUsuarioDtos.filter(f => f.encomendas !== null && situacoes.includes(f.situacao));
      if (detalhamentosUsuarios.length > 0) {
        return <table key={detalhamentosUsuarios.nomeVendedor}
                      className="table table-sm table-striped table-bordered text-center page-break">
          <thead>
          <tr>
            <td colSpan={9}>
              <strong>{titulo}</strong>
            </td>
          </tr>
          <tr>
            <th scope="col">Pedido</th>
            <th scope="col">Remetente</th>
            <th scope='col'>Situação</th>
            <th scope="col">Pagamento</th>
            <th scope="col">Imposto retido</th>
            <th scope="col">Comissão</th>
            <th scope="col">Valor de estorno</th>
            <th scope="col">Valor</th>
          </tr>
          </thead>
          <tbody>
          {detalhamentosUsuarios.map(detalhamento => detalhamento.encomendas.map(encomenda =>
            <tr key={`encomenda-${encomenda.id}`}>
              <td>
                <span>{encomenda.idPedido}</span>
              </td>
              <td>
                <span>{encomenda.remetente.nome}</span>
              </td>
              <td>
                <span>{detalhamento.situacao}</span>
              </td>
              <td>
                <span>{encomenda.descricaoFormasPagamento}</span>
              </td>
              <td>
                {detalhamento.situacao === 'Cancelado' ?
                  'R$ 0,00' :
                  <span>{formatarReal(encomenda.impostoRetido)}</span>
                }
              </td>
              <td>
                {detalhamento.situacao === 'Cancelado' ?
                  'R$ 0,00' :
                  <span>{formatarReal(encomenda.comissao)}</span>
                }
              </td>
              <td>
                <span>{detalhamento.situacao === 'Cancelado' ? formatarReal(encomenda.valor) : '-'}</span>
              </td>
              <td>
                {detalhamento.situacao === 'Cancelado' ? ' - ' : ''}
                <span>{formatarReal(encomenda.valor)}</span>
              </td>
            </tr>))}
          </tbody>
          {situacoes.includes('Aprovado') ?
            <tfoot>
            <tr className='border border-dark'>
              <td colSpan={4}>
                <strong><span>TOTAIS</span></strong>
              </td>
              <td><span>{formatarReal(fechamento.totalImpostoRetidoEncomenda)}</span></td>
              <td>{formatarReal(fechamento.totalComissaoEncomenda)}</td>
              <td/>
              <td>{formatarReal(fechamento.valorTotalEncomenda)}</td>
            </tr>
            </tfoot> : null
          }
        </table>
      }
      return null

    }
    return null
  }

  exbibirFechamento () {
    if (this.props.fechamentoCaixa.detalhamento) {
      const fechamentos = this.props.fechamentoCaixa.detalhamento;
      if (fechamentos.length) {
        return fechamentos.map((fechamento) =>
          <div key={fechamento.nomeVendedor}
               className='mt-2 p-2 border border-dark table-responsive'>
              <table className="table table-sm table-bordered">
                <tbody>
                <tr>
                  <td>Vendedor:</td>
                  <td>{fechamento.nomeVendedor}</td>
                </tr>
                </tbody>
              </table>
            {this.exbibirReservas(fechamento,['Em aberto', 'Em aberto/Reembolso Solicitado', 'Remarcada'], 'Reservas Abertas/Remarcadas')}
            {this.exbibirReservas(fechamento,['Cancelado', 'Cancelado/Reembolso Efetuado', 'Aprovado'], 'Reservas Canceladas/Aprovadas')}
            {this.exbibirEncomendas(fechamento,['Cancelado', 'Aprovado'], 'Encomendas Canceladas/Aprovadas')}
            {this.exbibirEncomendas(fechamento,['Em aberto', 'Remarcada'], 'Encomendas Abertas/Remarcadas')}
          </div>
        )
      }
      return null
    }
  }

  exibir () {
    return <React.Fragment>
      <div className='mt-2'>
        <div className="invoice-title">
          <div className="row justify-content-around">
            <div className="col-md-4">
              <strong> Empresa: {this.props.empresaSelecionada.nomeFantasia}</strong>
            </div>
            <div className="col-md-6">
              <strong>Agência: {this.props.fechamentoCaixa.nomeAgencia}</strong>
            </div>
            <div className="col-md-2">
              <strong>Data: {this.props.fechamentoCaixa.dataFechamento}</strong>
            </div>
          </div>
          <hr/>
        </div>
        <div className="row">
          <div className="col-md-6">
            <table className="table table-sm table-bordered">
              <tbody>
              {this.exbirLinhaTotal('(+) Total Tx de Serviço', this.props.fechamentoCaixa.totais.totalTaxaServico)}
              {this.exbirLinhaTotal('(+) Total Tx de Pedágio', this.props.fechamentoCaixa.totais.totalPedagio)}
              {this.exbirLinhaTotal('(+) Total adiantamento baixado', this.props.fechamentoCaixa.totais.totalAdiantamentoBaixado)}
              {this.exbirLinhaTotal('(-) Total adiantamento lançado', this.props.fechamentoCaixa.totais.totalAdiantamentoLancado)}
              {this.exbirLinhaTotal('(-) Total despesas', this.props.fechamentoCaixa.totais.totalDespesas)}
              {this.exbirLinhaTotal('(-) Total Lançamentos a receber', this.props.fechamentoCaixa.totais.totalLancamentoAReceber)}
              {this.exbirLinhaTotal('(-) Total imposto retido', this.props.fechamentoCaixa.totais.totalImpostoRetido)}
              {this.exbirLinhaTotal('(-) Total seguro e imposto retido', this.props.fechamentoCaixa.totais.totalTarifaSeguroImpostoRetido)}
              {this.exbirLinhaTotal('(+) Total de vendas', this.props.fechamentoCaixa.totais.totalVendas)}
              </tbody>
            </table>
          </div>
          <div className="col-md-6">
            <table className="table table-sm table-bordered">
              <tbody>

              {this.exbirLinhaTotal('(-) Total recebido cartão', this.props.fechamentoCaixa.totais.totalRecebidoCartao)}
              {this.exbirLinhaTotal('(-) Total de cancelamentos', this.props.fechamentoCaixa.totais.totalCancelamento)}
              {this.exbirLinhaTotal('(+) Total recebido cartão no site', this.props.fechamentoCaixa.totais.totalRecebidoCartaoSite)}
              {this.exbirLinhaTotal('(+) Total de residual de cancelamentos', this.props.fechamentoCaixa.totais.totalCustoCancelamento)}
              {this.exbirLinhaTotal('(+) Total excesso bagagem', this.props.fechamentoCaixa.totais.totalExcessoBagagem)}
              {this.exbirLinhaTotal('(-) Total comissão', this.props.fechamentoCaixa.totais.totalComissao)}
               {this.exbirLinhaTotal('(-) Total comissão Reimpressão', this.props.fechamentoCaixa.totais.totalReimpressaoRecibo)}
              {this.exbirLinhaTotal('( Informativo ) Total desconto', this.props.fechamentoCaixa.totais.totalDesconto)}
              {this.exbirLinhaTotal('(=) Total Tx de Embaque CEA', this.props.fechamentoCaixa.totais.totalTaxaEmbarqueCEA)}
              {this.exbirLinhaTotal('(=) Total do deposito', this.props.fechamentoCaixa.totais.totalDeposito)}
              </tbody>
            </table>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.exbibirFechamento()}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.exibirHistoricos()}
          </div>
        </div>
        <div className='row text-center mt-5'>
          <div className="col-md-12">
            <p style={{ textDecoration: 'overline' }}>Assinatura do Responsável (Por Extenso)</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  }

  exibirBotoes () {
    return (
      <React.Fragment>
        <div className='row justify-content-md-center mt-2' id='printPageButton'>
          <Link className="ml-2" to="/painel-fechamento-caixa-agencia">
            <button className='btn btn-sm btn-laranja'>Concluir</button>
          </Link>
          <a target="_BLANK" onClick={() => this.imprimir()} style={{ cursor: 'pointer' }}
             className="btn  btn-sm btn-laranja ml-2">
            <i className="material-icons mr-1" style={{
              fontSize: '18px',
              verticalAlign: 'middle'
            }}>
              &#xe8ad;
            </i>
            Imprimir
          </a>
        </div>
      </React.Fragment>)
  }

  render () {
    if (this.props.fechamentoCaixa) {
      return <React.Fragment>
        <div className="grid invoice">
          {this.exibirBotoes()}
          <div ref={this.componentRef} className="grid-body" id='cupom-encomenda' style={{
            fontSize: 16,
            fontWeight: 'bold'
          }}>
            <div className='text-center mb-4'>
              <h1>Fechamento de caixa Agência</h1>
            </div>
            {this.exibir()}
          </div>
          {this.exibirBotoes()}
        </div>
      </React.Fragment>
    }
    return '';
  }
}


export const mapStateToProps = state => (
  {
    empresaSelecionada: state.empresaSelecionada,
    fechamentoCaixa: state.fechamentoCaixa
  });


export default withRouter(connect(mapStateToProps, { buscarFechamentoCaixaAgencia })(PainelDetalhamentoFechamentoCaixaAgencia));
